import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';

interface NgLetContext<T> {
  ngLet: T | null;
}

@Directive({
  selector: '[ngLet]',
  standalone: true,
})
export class LetDirective<T> implements OnInit {

  private context: NgLetContext<T | null> = { ngLet: null };

  @Input()
  set ngLet(value: T | null) {
    this.context.ngLet = value;
  }

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<NgLetContext<T | null>>,
  ) {}

  ngOnInit() {
    this.viewContainer.createEmbeddedView(this.templateRef, this.context);
  }

  static ngTemplateContextGuard<T>(
    dir: LetDirective<T>,
    ctx: any
  ): ctx is NgLetContext<T> {
    return true;
  }

}
